<template>
  <div class="loginStyle">
    <h1>登入管理後台</h1>
    <Form :model="loginData">
      <FormItem label="統一編號">
        <Input
          type="text"
          v-model="loginData.taxNumber"
          placeholder="請輸入統一編號"
        >
          <Icon type="ios-person-outline" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <FormItem label="帳號">
        <Input type="text" v-model="loginData.account" placeholder="請輸入帳號">
          <Icon type="ios-person-outline" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <FormItem label="密碼">
        <Input
          type="password"
          v-model="loginData.password"
          placeholder="請輸入密碼"
        >
          <Icon type="ios-lock-outline" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="login" long>登入</Button>
      </FormItem>
    </Form>
    <div class="login-footer">
      <h1 class="login-footer-title">GLAD Taxi 享受生活</h1>
      <p>©2018-{{ currentYear }} 資通行動科技有限公司</p>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import axios from "axios";
import Cookies from "js-cookie";
import API from "../asset/js/API";

export default {
  mounted() {
    const token = Cookies.get("token");
    // if (token === null || token === undefined) this.$router.replace({ name: "Main" });
  },
  data() {
    return {
      loginData: {
        taxNumber: "",
        account: "",
        password: ""
      }
    };
  },
  computed: {
    currentYear() {
      return dayjs().format("YYYY");
    }
  },
  methods: {
    login: async function() {
      const { teamCode, taxNumber, account, password } = this.loginData;
      API.post("manager/login", {
        taxNumber,
        account,
        password
      })
        .then(res => {
          if (!res.success) {
            this.closable(res.result);
          } else {
            // addAllCookies(res.result);
            Cookies.set("companyName", res.result.companyName);
            Cookies.set("employee", res.result.employee);
            Cookies.set("manager", res.result.manager);
            Cookies.set("managerName", res.result.managerName);
            Cookies.set("position", res.result.position);
            Cookies.set("positionId", res.result.positionId);
            Cookies.set("signing", res.result.signing);
            Cookies.set("token", res.result.token);
            API.defaults.headers.common["x-access-token"] = Cookies.getJSON(
              "token"
            );
            this.$router.replace("/employeelist");
          }
        })
        .catch(err => {
          console.error("取得員工列表", err);
        });
    },
    closable(message) {
      this.$Message.error({
        content: message,
        duration: 3,
        closable: true
      });
    }
  }
};
</script>

<style lang="scss">
.loginStyle {
  margin: 60px auto;
  padding: 50px;
  width: 500px;
  border: 1px solid #e4e4e4;
  border-radius: 5px;
  background-color: #f5f7f9;
}

.login-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin: 0 auto;
  }
}

.login-footer-title {
  color: #73879c;
  font-size: 25px;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 400;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue